module.exports = __webpack_public_path__ + "img/invitation.85294cba.png";